<template>
  <div class="container-fluid register-wrapper">
    <div class="register-container">

      <!-- HEADER -->
      <div class="auth-header">
        <div class="brand">
          <router-link :to="{ name: 'login' }" class="logo-link">
            <img src="../assets/images/logo/logo.png" alt="TusCFDI" height="32" />
          </router-link>
        </div>
        <div class="auth-link">
          <span>¿Ya tienes cuenta?</span>
          <router-link :to="{ name: 'login' }" class="btn btn-outline-primary btn-sm">
            Iniciar sesión
          </router-link>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="row justify-content-center align-items-center min-vh-100 pt-5">
        <div class="col-xl-9 col-lg-10">
          <div class="register-card">

            <!-- LEFT -->
            <div class="register-left">
              <span class="badge mb-4">Tu mejor Opción</span>

              <h1>
                Tu información fiscal en tiempo real.
              </h1>
              <p>
                Descarga, organiza y analiza automaticamente todos tus CFDIs.
              </p>
              <br>
              <p>
                Anticipa cuánto pagarás antes de declarar
              </p>
              <div class="trust mt-auto">
                <div class="avatars"></div>
                <span>Descubre una mejor forma de visualizar tus CFDIs</span>
              </div>
            </div>

            <!-- RIGHT -->
            <div class="register-right">
              <h2>Prueba tu cuenta gratuita por 30 días</h2>
              <p class="text-muted mb-4">
                Completa los datos para comenzar.
              </p>
              <form ref="registerForm" class="theme-form" autocomplete="off" @submit.prevent="submit">
                <div v-if="formError" class="alert alert-danger" role="alert">{{ formError }}</div>

                <input type="hidden" :value="form.cardExpMonth" data-conekta="card[exp_month]" />
                <input type="hidden" :value="form.cardExpYear" data-conekta="card[exp_year]" />
                <input type="hidden" :value="form.cardAddressStreet" data-conekta="card[address][street1]" />
                <input type="hidden" :value="form.cardAddressCity" data-conekta="card[address][city]" />
                <input type="hidden" :value="form.cardAddressState" data-conekta="card[address][state]" />
                <input type="hidden" :value="form.cardAddressCountry" data-conekta="card[address][country]" />
                <input type="hidden" :value="form.cardAddressZip" data-conekta="card[address][zip]" />

                <!-- NOMBRE -->
                <div class="form-group mb-3">
                  <label>Nombre completo</label>
                  <input type="text" class="form-control form-control-lg" placeholder="Juan Pérez" v-model="form.name" autocomplete="off"
                    @input="normalizeName" @blur="v$.form.name.$touch()" :class="{ 'is-invalid': v$.form.name.$error }" />
                  <div class="invalid-feedback d-block" v-if="v$.form.name.$error">
                    <span v-if="v$.form.name.$errors.length">
                      {{ v$.form.name.$errors[0].$message }}
                    </span>
                  </div>
                </div>

                <div class="row">

                  <!-- EMAIL -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Correo electrónico</label>
                    <input type="email" class="form-control form-control-lg" placeholder="juan@empresa.com" autocomplete="off"
                      v-model="form.email" @input="normalizeEmail" @blur="v$.form.email.$touch()"
                      :class="{ 'is-invalid': v$.form.email.$error }" />
                    <div class="invalid-feedback" v-if="v$.form.email.$error">
                      <span v-if="v$.form.email.$errors.length">
                        {{ v$.form.email.$errors[0].$message }}
                      </span>
                    </div>
                  </div>

                  <!-- WHATSAPP -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Whatsapp</label>
                    <input type="tel" class="form-control form-control-lg" placeholder="5512345678 o +14155552671" autocomplete="off"
                      v-model="form.phone" @blur="v$.form.phone.$touch()"
                      :class="{ 'is-invalid': v$.form.phone.$error }" />
                   <div class="invalid-feedback d-block" v-if="v$.form.phone.$error">
                    <span v-if="v$.form.phone.$errors.length">
                      {{ v$.form.phone.$errors[0].$message }}
                    </span>
                  </div>
                  </div>

                </div>

                <h6 class="mt-3 mb-2">Tarjeta para activar prueba gratuita</h6>
                <p class="text-muted mb-3">
                  No realizaremos ningún cargo. Tu prueba gratuita es de 30 días y programaremos tu primer cobro automático al finalizar el periodo.
                </p>

                <div class="row">
                  <div class="form-group mb-3">
                    <label>Nombre del titular</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      autocomplete="off"
                      placeholder="JUAN PEREZ"
                      v-model="form.cardHolder"
                      @input="onUppercaseCardInput('cardHolder', $event)"
                      @blur="v$.form.cardHolder.$touch()"
                      :class="{ 'is-invalid': v$.form.cardHolder.$error }"
                      data-conekta="card[name]"
                    />
                    <div class="invalid-feedback d-block" v-if="v$.form.cardHolder.$error">
                      {{ v$.form.cardHolder.$errors[0].$message }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 form-group mb-3">
                    <label>Número de tarjeta</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      autocomplete="off"
                      placeholder="4242424242424242"
                      v-model="form.cardNumber"
                      @input="onCardNumberInput"
                      @blur="v$.form.cardNumber.$touch()"
                      :class="{ 'is-invalid': v$.form.cardNumber.$error }"
                      inputmode="numeric"
                      maxlength="16"
                      data-conekta="card[number]"
                    />
                    <div class="invalid-feedback d-block" v-if="v$.form.cardNumber.$error">
                      {{ v$.form.cardNumber.$errors[0].$message }}
                    </div>
                  </div>
                  <div class="col-md-3 form-group mb-3">
                    <label>Expira</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      autocomplete="off"
                      placeholder="MM/AA"
                      v-model="form.cardExpiration"
                      @input="onExpirationInput"
                      @blur="v$.form.cardExpiration.$touch()"
                      :class="{ 'is-invalid': v$.form.cardExpiration.$error }"
                      maxlength="5"
                    />
                    <div class="invalid-feedback d-block" v-if="v$.form.cardExpiration.$error">
                      {{ v$.form.cardExpiration.$errors[0].$message }}
                    </div>
                  </div>

                  <div class="col-md-3 form-group mb-3">
                    <label>CVV</label>
                    <input
                      type="password"
                      class="form-control form-control-lg"
                      autocomplete="off"
                      placeholder="***"
                      v-model="form.cardCvv"
                      @input="onCardCvvInput"
                      @blur="v$.form.cardCvv.$touch()"
                      :class="{ 'is-invalid': v$.form.cardCvv.$error }"
                      inputmode="numeric"
                      maxlength="4"
                      data-conekta="card[cvc]"
                    />
                    <div class="invalid-feedback d-block" v-if="v$.form.cardCvv.$error">
                      {{ v$.form.cardCvv.$errors[0].$message }}
                    </div>
                  </div>

                </div>

                <div class="form-group mb-3">
                  <input type="checkbox" class="checkbox_animated me-2" v-model="form.acceptAutoCharge" @change="v$.form.acceptAutoCharge.$touch()" />
                  <span>
                    Entiendo que se programará un primer cobro automático al terminar mi prueba gratuita de 30 días y que puedo cancelar el cobro automático en cualquier momento desde mi cuenta.
                  </span>
                  <div class="invalid-feedback d-block" v-if="v$.form.acceptAutoCharge.$error">
                    {{ v$.form.acceptAutoCharge.$errors[0].$message }}
                  </div>
                </div>

                <div class="row">

                  <!-- PASSWORD -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Contraseña</label>
                    <div class="position-relative">
                      <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg pe-5" autocomplete="off"
                        placeholder="••••••••" v-model="form.password" @blur="v$.form.password.$touch()"
                        :class="{ 'is-invalid': v$.form.password.$error }" />
                      <span class="toggle-password" @click="showPassword = !showPassword">
                        👁
                      </span>
                    </div>
                    <div class="invalid-feedback d-block" v-if="v$.form.password.$error">
                      <span v-if="v$.form.password.$errors.length">
                        {{ v$.form.password.$errors[0].$message }}
                      </span>
                    </div>
                  </div>

                  <!-- CONFIRM PASSWORD -->
                  <div class="col-md-6 form-group mb-3">
                    <label>Confirmar contraseña</label>
                    <input type="password" class="form-control form-control-lg" placeholder="••••••••" autocomplete="off"
                      v-model="form.passwordConfirm" @blur="v$.form.passwordConfirm.$touch()"
                      :class="{ 'is-invalid': v$.form.passwordConfirm.$error }" />
                    <div class="invalid-feedback" v-if="v$.form.passwordConfirm.$error">
                      <span v-if="v$.form.passwordConfirm.$errors.length">
                        {{ v$.form.passwordConfirm.$errors[0].$message }}
                      </span>
                    </div>
                  </div>

                </div>

                <div class="form-group mb-4">
                  <input type="checkbox" class="checkbox_animated me-2" v-model="form.acceptTerms" @change="v$.form.acceptTerms.$touch()" />
                  <span>
                    Acepto los
                    <a href="https://tuscfdis.com/terminos">Términos de Servicio</a>
                    y la
                    <a href="https://tuscfdis.com/politica-privacidad">Política de Privacidad</a>
                    de TusCFDI.
                  </span>
                  <div class="invalid-feedback d-block" v-if="v$.form.acceptTerms.$error">
                    {{ v$.form.acceptTerms.$errors[0].$message }}
                  </div>
                </div>

                <button class="btn btn-primary btn-lg w-100">
                  Continuar
                </button>

              </form>

            </div>

          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="auth-footer">
        <div class="footer-links">
          <a target="_blank" href="https://tuscfdis.com/terminos">Términos</a>
          <a target="_blank" href="https://tuscfdis.com/politica-privacidad">Privacidad</a>
        </div>
        <small>© 2026 TusCFDIs.</small>
      </div>
    </div>
  </div>
</template>

<script>
import ws from '@/services/login';
import { pushGtmEvent } from '@/services/gtm';
import { normalizeEmail, normalizeName } from '@/mixins/normalizers';
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, sameAs, helpers } from '@vuelidate/validators';
import moment from 'moment';

const normalizeWhatsappInput = (value) => String(value || '').trim().replace(/[\s()-]/g, '')

const whatsappFormat = helpers.withMessage(
  'Captura un WhatsApp válido: 10 dígitos o formato internacional con +',
  (value) => {
    const normalized = normalizeWhatsappInput(value)
    if (!normalized) return false

    if (normalized.startsWith('+')) {
      const digits = normalized.slice(1)
      return /^\d+$/.test(digits) && digits.length >= 8
    }

    return /^\d{10}$/.test(normalized)
  }
)

const cardExpirationFormat = helpers.withMessage(
  'Captura la expiración en formato MM/AA válido',
  (value) => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 4)
    if (digits.length !== 4) return false

    const month = Number(digits.slice(0, 2))
    return month >= 1 && month <= 12
  }
)

export default {
  name: 'register',
  data() {
    return {
      showPassword: false,
      formError: '',
      form: {
        name: '',
        email: '',
        phone: '',
        password: '',
        passwordConfirm: '',
        acceptTerms: false,
        cardHolder: '',
        cardNumber: '',
        cardExpiration: '',
        cardExpMonth: '',
        cardExpYear: '',
        cardCvv: '',
        cardAddressStreet: 'CALLE 1',
        cardAddressCity: 'MONTERREY',
        cardAddressState: 'NLE',
        cardAddressCountry: 'MX',
        cardAddressZip: '64000',
        acceptAutoCharge: false,
      }
    }
  },
  validations() {
    return {
      form: {
        name: { 
          required: helpers.withMessage('El nombre es obligatorio', required),
          minLength: helpers.withMessage('El nombre debe tener al menos 3 caracteres', minLength(3)) },
        email: { required: helpers.withMessage('El correo es obligatorio', required), email: helpers.withMessage('Correo inválido', email) },
        phone: {
          required: helpers.withMessage('El WhatsApp es obligatorio', required),
          whatsappFormat,
        },
        password: { required: helpers.withMessage('La contraseña es obligatoria', required), minLength: helpers.withMessage('Mínimo 8 caracteres', minLength(8)) },
        passwordConfirm: { required: helpers.withMessage('Confirma tu contraseña', required), sameAsPassword: helpers.withMessage('Las contraseñas no coinciden', sameAs(this.form.password)) },
        acceptTerms: { required: helpers.withMessage('Debes aceptar los términos', sameAs(true))},
        cardHolder: { required: helpers.withMessage('El nombre del titular es obligatorio', required) },
        cardNumber: { required: helpers.withMessage('El número de tarjeta es obligatorio', required), valid: helpers.withMessage('Debe contener 15 o 16 dígitos', (value) => /^[0-9]{15,16}$/.test(String(value || ''))) },
        cardExpiration: { required: helpers.withMessage('La expiración es obligatoria', required), cardExpirationFormat },
        cardCvv: { required: helpers.withMessage('El CVV es obligatorio', required), valid: helpers.withMessage('Debe contener 3 o 4 dígitos', (value) => /^[0-9]{3,4}$/.test(String(value || ''))) },
        acceptAutoCharge: { required: helpers.withMessage('Debes aceptar la programación del cobro automático', sameAs(true)) },
      }
    }
  },
  setup() {
    const v$ = useVuelidate()
    return { v$ }
  },
  mounted() {
    pushGtmEvent('registration_form_view', {
      screen_name: 'register',
      flow: 'email_registration',
    })

    this.processGoogleAuthFromHash()
  },
  methods: {
    sanitizeUiErrorMessage(message) {
      const normalized = String(message || '').trim()
      if (!normalized) {
        return ''
      }

      const lowered = normalized.toLowerCase()
      const technicalPatterns = [
        'could not be opened in append mode',
        'permission denied',
        'while attempting to log',
        '/var/www/',
        'stack trace',
      ]

      if (technicalPatterns.some((pattern) => lowered.includes(pattern))) {
        return 'No fue posible completar el registro por un error temporal del servidor. Intenta nuevamente en unos minutos.'
      }

      return normalized.length > 300 ? `${normalized.slice(0, 300)}...` : normalized
    },
    showWhatsappTakenToast(message) {
      const normalized = String(message || '').trim()
      if (normalized !== 'Este número de WhatsApp ya está vinculado a otra cuenta.') {
        return
      }

      this.$toast.error('Este número de WhatsApp ya está vinculado a otra cuenta.')
    },
    getGoogleClientId() {
      return String(process.env.VUE_APP_GOOGLE_CLIENT_ID || '').trim()
    },
    generateOAuthState() {
      return Math.random().toString(36).slice(2) + Date.now().toString(36)
    },
    async processGoogleAuthFromHash() {
      this.formError = ''
      const hash = String(window.location.hash || '')
      if (!hash.startsWith('#')) return

      const params = new URLSearchParams(hash.slice(1))
      const idToken = params.get('id_token')
      const state = params.get('state')
      const error = params.get('error')

      if (!idToken && !error) return

      window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`)

      if (error) {
        this.formError = 'No fue posible autenticar con Google'
        return
      }

      const expectedState = sessionStorage.getItem('google_oauth_state')
      sessionStorage.removeItem('google_oauth_state')

      if (!expectedState || state !== expectedState) {
        this.formError = 'La sesión de Google no es válida, intenta nuevamente'
        return
      }

      await this.loginWithGoogleIdToken(idToken)
    },
    startGoogleAuth() {
      this.formError = ''
      const clientId = this.getGoogleClientId()
      if (!clientId) {
        this.formError = 'Google OAuth no está configurado. Falta VUE_APP_GOOGLE_CLIENT_ID'
        return
      }

      const state = this.generateOAuthState()
      const nonce = this.generateOAuthState()
      const redirectUri = `${window.location.origin}${window.location.pathname}`

      sessionStorage.setItem('google_oauth_state', state)

      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth')
      authUrl.searchParams.set('client_id', clientId)
      authUrl.searchParams.set('redirect_uri', redirectUri)
      authUrl.searchParams.set('response_type', 'id_token')
      authUrl.searchParams.set('scope', 'openid email profile')
      authUrl.searchParams.set('prompt', 'select_account')
      authUrl.searchParams.set('nonce', nonce)
      authUrl.searchParams.set('state', state)

      window.location.assign(authUrl.toString())
    },
    applySession(data) {
      const token = data.token
      const user = data.user

      localStorage.setItem('access_token', token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('rfcs', JSON.stringify(user.rfcs || []))
      localStorage.setItem('period', moment().format("YYYY-MM"))

      if (user.rfc) {
        localStorage.setItem('rfc', user.rfc.rfc)
        localStorage.setItem('fiscal_name', user.rfc.name)
        this.$router.push({ name: 'dashboard' })
      } else {
        localStorage.setItem('rfc', "")
        localStorage.setItem('fiscal_name', "")
        this.$router.push({ name: 'settings', query: { section: 'rfcs' } })
      }
    },
    async loginWithGoogleIdToken(idToken) {
      this.formError = ''
      this.$loading.show()
      try {
        const response = await ws.loginGoogle(idToken)
        if (response.type !== 'success') {
          this.formError = response.message
          return
        }

        this.applySession(response.data)
      } catch (e) {
        this.formError = 'Error al iniciar sesión con Google'
      } finally {
        this.$loading.hide()
      }
    },
    normalizeName() {
      this.form.name = normalizeName(this.form.name)
    },
    normalizeEmail() {
      this.form.email = normalizeEmail(this.form.email)
    },
    onUppercaseCardInput(field, event) {
      const value = event?.target?.value || ''
      this.form[field] = value.toUpperCase()
    },
    onCardNumberInput(event) {
      const value = event?.target?.value || ''
      this.form.cardNumber = value.replace(/\D/g, '').slice(0, 16)
    },
    onCardCvvInput(event) {
      const value = event?.target?.value || ''
      this.form.cardCvv = value.replace(/\D/g, '').slice(0, 4)
    },
    onExpirationInput(event) {
      const rawValue = event?.target?.value || ''
      const onlyDigits = rawValue.replace(/\D/g, '').slice(0, 4)

      if (onlyDigits.length <= 2) {
        this.form.cardExpiration = onlyDigits
        return
      }

      this.form.cardExpiration = `${onlyDigits.slice(0, 2)}/${onlyDigits.slice(2)}`
    },
    parseExpiration(value) {
      const digits = String(value || '').replace(/\D/g, '').slice(0, 4)
      if (digits.length !== 4) {
        return null
      }

      const month = digits.slice(0, 2)
      const year = digits.slice(2, 4)
      const monthNumber = Number(month)
      if (monthNumber < 1 || monthNumber > 12) {
        return null
      }

      return { month, year }
    },
    async ensureConektaLoaded() {
      if (window.Conekta && typeof window.Conekta.Token?.create === 'function') {
        return
      }

      const existing = document.querySelector('script[data-conekta-sdk="true"]')
      if (existing) {
        if (window.Conekta && typeof window.Conekta.Token?.create === 'function') {
          return
        }

        await new Promise((resolve, reject) => {
          existing.addEventListener('load', resolve, { once: true })
          existing.addEventListener('error', reject, { once: true })
        })
        return
      }

      await new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = 'https://cdn.conekta.io/js/latest/conekta.js'
        script.async = true
        script.defer = true
        script.dataset.conektaSdk = 'true'
        script.onload = resolve
        script.onerror = () => reject(new Error('No se pudo cargar Conekta.js'))
        document.head.appendChild(script)
      })
    },
    async createConektaToken(formElement) {
      return new Promise((resolve, reject) => {
        window.Conekta.Token.create(
          formElement,
          (token) => resolve(token),
          (error) => reject(error),
        )
      })
    },
    async submit() {
      this.formError = ''
      this.normalizeName()
      this.normalizeEmail()

      this.v$.$touch()

      if (this.v$.$invalid) return

      this.$loading.show();
      try {
        const parsedExpiration = this.parseExpiration(this.form.cardExpiration)
        if (!parsedExpiration) {
          this.formError = 'La fecha de expiración de la tarjeta no es válida.'
          return
        }

        this.form.cardExpMonth = parsedExpiration.month
        this.form.cardExpYear = parsedExpiration.year

        const conektaPublicKey = String(process.env.VUE_APP_CONEKTA_PUBLIC_KEY || '').trim()
        if (!conektaPublicKey) {
          this.formError = 'No se ha configurado la llave pública de Conekta (VUE_APP_CONEKTA_PUBLIC_KEY).'
          return
        }

        await this.ensureConektaLoaded()
        if (!window.Conekta || typeof window.Conekta.Token?.create !== 'function') {
          this.formError = 'No fue posible inicializar Conekta en el navegador.'
          return
        }

        window.Conekta.setPublicKey(conektaPublicKey)
        const token = await this.createConektaToken(this.$refs.registerForm)

        const payload = {
          name: normalizeName(this.form.name),
          email: normalizeEmail(this.form.email),
          phone: this.form.phone,
          password: this.form.password,
          passwordConfirm: this.form.passwordConfirm,
          acceptTerms: this.form.acceptTerms,
          accept_auto_charge: this.form.acceptAutoCharge,
          conekta_token_id: token?.id || '',
          card_holder: this.form.cardHolder,
          card_last4: this.form.cardNumber.slice(-4),
          card_exp_month: this.form.cardExpMonth,
          card_exp_year: this.form.cardExpYear,
          card_brand: token?.card?.brand || 'TARJETA',
        }

        const res = await ws.register(payload)
        if (res.type !== 'success') {
          this.showWhatsappTakenToast(res.message)
          this.formError = res.message
          return
        }

        this.$router.push({
          name: 'verifyAccount',
          query: { email: payload.email }
        })

        pushGtmEvent('registration_verification_form_redirect', {
          screen_name: 'verify_account',
          flow: 'email_registration',
        })

      } catch (e) {
        console.error('Conekta tokenization error (register)', e)

        const errorCode = String(e?.code || e?.response?.data?.code || '').trim()
        const purchaserMessage = e?.message_to_purchaser || e?.response?.data?.message_to_purchaser || ''
        const detailMessage = Array.isArray(e?.details) && e.details.length > 0
          ? e.details
              .map((detail) => String(detail?.message || '').trim())
              .filter((detail) => detail !== '')
              .join(' ')
          : ''
        const apiMessage = e?.response?.data?.message || ''
        const technicalFallback = String(e?.message || '').trim()
        const composedMessage = [purchaserMessage, detailMessage, apiMessage, technicalFallback]
          .find((message) => String(message || '').trim() !== '') || 'Error inesperado'

        this.showWhatsappTakenToast(apiMessage)
        const safeMessage = this.sanitizeUiErrorMessage(composedMessage)
        this.formError = errorCode ? `${safeMessage} (Código ${errorCode})` : safeMessage
      } finally {
        this.$loading.hide();
      }

    }
  }
}

</script>
